import axios from "axios";
import instance from "../api/axios";

export const vars = {
    folder1: "ttpro",
    folder2: "blogs",
    folder3: "news",
    upload: "upload",
    url: "https://admin1.ttpro.in"
}

export const uploadImageViaApi = async (img, folders) => {
  try {
    let data = new FormData();
    data.append("image", img);

    const response = await axios.post(
      `${vars.url}/${vars.upload}/${vars.folder1}/${folders}`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    // if(response.data.code === 1){
    //     return response.data.file_name
    // }else{
    //     return ""
    // }
    return response.data
  } catch (error) {
      console.error("Upload failed:", error);
    return {error: error.message}
  }
};
